// Mock data para Grupo BG - Grupo Empresarial de Distribución

export const companyInfo = {
  name: "Grupo BG",
  fullName: "Grupo BG Distribuciones",
  tagline: "Conectamos marcas con puntos de venta en la zona centro del Ecuador",
  description: "Empresa de distribución especializada en productos de consumo masivo, enfocada en cobertura regional, logística eficiente y fuerza de ventas especializada.",
  location: "Río Toachi y Río Muisne, Riobamba - Ecuador",
  email: "contacto@grupobg.com.ec",
  phone: "+593 983112804",
  whatsapp: "593983112804",
  mapsUrl: "https://www.google.com/maps/place/Rio+BG+Distribuciones/@-1.6417745,-78.6670506,17z/data=!4m15!1m8!3m7!1s0x91d30807c6f7b907:0x63915f2513b3f65f!2sRio+Toachi+%26+Rio+Muisne,+Riobamba!3b1!8m2!3d-1.6417745!4d-78.6670506!16s%2Fg%2F11f37ypv9h!3m5!1s0x91d309c05e9a6c49:0xbed7b19946520e7e!8m2!3d-1.6420051!4d-78.6670147!16s%2Fg%2F11q2xcddwc?entry=ttu&g_ep=EgoyMDI2MDIwNC4wIKXMDSoASAFQAw%3D%3D",
  logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/ez0jkvnw_LOGO%20PNG%20PW.png",
  logoAlt: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/qi9smcb3_Logo-Rio-BG-2022-PNG%20PW.png"
};

export const warehouses = [
  {
    id: 1,
    name: "Riobamba",
    province: "Chimborazo",
    address: "Río Toachi y Río Muisne",
    mapsUrl: "https://www.google.com/maps/place/Rio+BG+Distribuciones/@-1.6417745,-78.6670506,17z/data=!4m15!1m8!3m7!1s0x91d30807c6f7b907:0x63915f2513b3f65f!2sRio+Toachi+%26+Rio+Muisne,+Riobamba!3b1!8m2!3d-1.6417745!4d-78.6670506!16s%2Fg%2F11f37ypv9h!3m5!1s0x91d309c05e9a6c49:0xbed7b19946520e7e!8m2!3d-1.6420051!4d-78.6670147!16s%2Fg%2F11q2xcddwc?entry=ttu&g_ep=EgoyMDI2MDIwNC4wIKXMDSoASAFQAw%3D%3D"
  },
  {
    id: 2,
    name: "Guaranda",
    province: "Bolívar",
    address: "Rio BG Distribuciones Guaranda",
    mapsUrl: "https://www.google.com/maps/place/Rio+BG+Distribuciones+Guaranda/@-1.5593431,-79.0130314,17z/data=!3m1!4b1!4m6!3m5!1s0x91d3152babdeade5:0x18e078c0b0f695f3!8m2!3d-1.5593485!4d-79.0081605!16s%2Fg%2F11rzpbrlvb?entry=ttu&g_ep=EgoyMDI2MDIwNC4wIKXMDSoASAFQAw%3D%3D"
  },
  {
    id: 3,
    name: "Macas",
    province: "Morona Santiago",
    address: "Rio BG Distribuciones Macas",
    mapsUrl: "https://www.google.com/maps/place/Rio+BG+Distribuciones+Macas/@-2.2870279,-78.1923705,12.54z/data=!4m10!1m2!2m1!1sRio+BG+Distribuciones+mACAS!3m6!1s0x2aa9b029a1ee951b:0xbadd10b6d6ba01e2!8m2!3d-2.318289!4d-78.1307062!15sChtSaW8gQkcgRGlzdHJpYnVjaW9uZXMgbUFDQVOSAQVzdG9yZeABAA!16s%2Fg%2F11w8ngy5bk?entry=ttu&g_ep=EgoyMDI2MDIwNC4wIKXMDSoASAFQAw%3D%3D"
  },
  {
    id: 4,
    name: "Ambato",
    province: "Tungurahua",
    address: "Rio BG Distribuciones Ambato",
    mapsUrl: "https://www.google.com/maps/place/Rio+BG+Distribuciones+Ambato/@-1.2766769,-78.6360887,17z/data=!3m1!4b1!4m6!3m5!1s0x91d38304edf24ffb:0xbbf383ec1c2ffd23!8m2!3d-1.2766823!4d-78.6335138!16s%2Fg%2F11z9vxdpnh?entry=ttu&g_ep=EgoyMDI2MDYyNC4wIKXMDSoASAFQAw%3D%3D"
  }
];

export const coverageData = {
  currentProvinces: [
  { name: "Chimborazo", status: "activo" },
  { name: "Bolívar", status: "activo" },
  { name: "Morona Santiago", status: "activo" },
  { name: "Tungurahua", status: "activo" },
  { name: "Pastaza", status: "activo" },
  { name: "Napo", status: "activo" },
  { name: "Cotopaxi", status: "activo" }],

  projectedProvinces: []

};

export const brands = [
  { 
    id: 1, 
    name: "ARCOR", 
    category: "Alimentos",
    logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/9w7idm74_LOGO%20ARCOR%20PNG.jpg"
  },
  { 
    id: 2, 
    name: "ESTRELLA", 
    category: "Limpieza",
    logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/97v75p74_LOGO%20ESTRELLA%20PNG.png"
  },
  { 
    id: 3, 
    name: "MINERVA", 
    category: "Café",
    logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/af7e17fo_LOGO%20MINERVA%20PNG.png"
  },
  { 
    id: 4, 
    name: "INGESA", 
    category: "Medias",
    logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/6f7yvmfe_LOGO%20INGESA%20PNG.jpg"
  },
  { 
    id: 5, 
    name: "INALECSA", 
    category: "Repostería",
    logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/qsxacovp_LOGO%20INALECSA.jpg"
  },
  { 
    id: 6, 
    name: "CARLI SNACKS", 
    category: "Snacks",
    logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/c2j85ppz_LOGO%20CARLI.webp"
  },
  { 
    id: 7, 
    name: "DULCENAC", 
    category: "Cereales",
    logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/m99evmua_LOGO%20DULCENAC.png"
  },
  { 
    id: 8, 
    name: "ELITE", 
    category: "Papel",
    logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/ar9seo5y_LOGO%20ELITE.webp"
  },
  { 
    id: 9, 
    name: "SUNNY", 
    category: "Bebidas",
    logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/cx9llqj1_LOGO%20SUNNY.png"
  },
  { 
    id: 10, 
    name: "HORNIMANS", 
    category: "Infusiones",
    logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/aay0x96b_HORMIMANS%20LOGO.png"
  },
  { 
    id: 11, 
    name: "SUMESA", 
    category: "Alimentos",
    logo: "https://customer-assets.emergentagent.com/job_0e67af74-5a77-4dee-9df5-6f50898d0c24/artifacts/6xmglj6a_image.png"
  },
  { 
    id: 12, 
    name: "CARTAGO", 
    category: "Destilería",
    logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/8ukzech7_LOGO%20CARTAGO.jpeg"
  },
  { 
    id: 13, 
    name: "SANGAY FOODS", 
    category: "Infusiones",
    logo: "https://customer-assets.emergentagent.com/job_919421c8-e199-4ae1-a91b-ce5ba8009637/artifacts/6ppqtlm4_SANGAY%20LOGO.png"
  },
  { 
    id: 14, 
    name: "FORESTEA", 
    category: "Infusiones",
    logo: "https://customer-assets.emergentagent.com/job_0e67af74-5a77-4dee-9df5-6f50898d0c24/artifacts/w6akz68q_forestea_logo1.png"
  },
  { 
    id: 15, 
    name: "DISPACIF", 
    category: "Cereales",
    logo: "https://customer-assets-agu9un31.emergentagent.net/job_0e67af74-5a77-4dee-9df5-6f50898d0c24/artifacts/im1vgag4_Quaker-Oats-Logo.webp"
  }
];


export const distributionModel = [
{
  title: "Fuerza de Ventas Estructurada",
  description: "Equipo profesional capacitado para atender todos los canales de distribución",
  icon: "users"
},
{
  title: "Distribución Numérica",
  description: "Cobertura efectiva en puntos de venta tradicionales y modernos",
  icon: "map-pin"
},
{
  title: "Ejecución en Punto de Venta",
  description: "Merchandising y gestión de inventarios en cada ubicación",
  icon: "shopping-cart"
},
{
  title: "Logística Eficiente",
  description: "Operación desde base central con rutas optimizadas",
  icon: "truck"
}];


export const valueProposition = [
{
  title: "Cobertura Efectiva",
  description: "Alcance en la zona centro del Ecuador con planes de expansión estratégica",
  stat: "7 Provincias",
  icon: "map"
},
{
  title: "Ejecución Comercial",
  description: "Fuerza de ventas comprometida con el crecimiento de nuestras marcas aliadas",
  stat: "15 Marcas",
  icon: "trending-up"
},
{
  title: "Crecimiento Sostenible",
  description: "Experiencia comprobada en canales tradicionales y modernos",
  stat: "+17 A\xF1os",
  icon: "award"
}];


export const images = {
  hero: "https://images.unsplash.com/photo-1763752194641-3c5638aec65e",
  heroAlt: "https://images.unsplash.com/photo-1768796373552-1168cb598645",
  about: "https://images.unsplash.com/photo-1568992687947-868a62a9f521",
  team: "https://images.unsplash.com/photo-1600880292089-90a7e086ee0c",
  warehouse: "https://images.unsplash.com/photo-1553413077-190dd305871c",
  warehouseAlt: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866",
  coverage: "https://images.unsplash.com/photo-1762134668781-517a582c3a8e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzd8MHwxfHNlYXJjaHwxfHxDaGltYm9yYXpvJTIwdm9sY2FubyUyMEVjdWFkb3IlMjBtb3VudGFpbiUyMHNub3clMjBwZWFrfGVufDB8fHx8MTc3MDMxMTk1Mnww&ixlib=rb-4.1.0&q=85",
  mountains: "https://images.unsplash.com/photo-1727030117341-cbe469dff244",
  contact: "https://images.unsplash.com/photo-1626863905121-3b0c0ed7b94c",
  fleet: "https://images.unsplash.com/photo-1587813369290-091c9d432daf"
};

export const blogPosts = [
  {
    id: 1,
    slug: "distribuidor-consumo-masivo-ecuador",
    title: "¿Por Qué Tu Marca Necesita un Distribuidor de Consumo Masivo en Ecuador?",
    excerpt: "Descubre las ventajas de contar con un distribuidor especializado para llevar tus productos a miles de puntos de venta en la zona centro del Ecuador.",
    image: "https://images.unsplash.com/photo-1553413077-190dd305871c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHw0fHxwcm9kdWN0JTIwZGlzdHJpYnV0aW9uJTIwbG9naXN0aWNzJTIwc3VwcGx5JTIwY2hhaW58ZW58MHx8fHwxNzgyNTk2NTgxfDA&ixlib=rb-4.1.0&q=85",
    date: "20 Abril 2026",
    readTime: "5 min",
    category: "Distribución",
    content: [
      "El mercado ecuatoriano de consumo masivo es altamente competitivo. Para las marcas que buscan posicionarse en la zona centro del país, contar con un distribuidor especializado no es una opción, es una necesidad estratégica.",
      "Un distribuidor de consumo masivo como Grupo BG ofrece infraestructura logística, fuerza de ventas capacitada y conocimiento profundo del mercado regional. Esto permite a las marcas enfocarse en la producción y el desarrollo de producto, mientras el distribuidor se encarga de la colocación efectiva en tiendas, supermercados y canales tradicionales.",
      "La cobertura en provincias como Chimborazo, Bolívar, Tungurahua, Pastaza, Morona Santiago y Napo requiere un operador logístico que conozca las rutas, los puntos de venta y las dinámicas comerciales de cada zona. Un distribuidor local tiene relaciones establecidas con tenderos y comerciantes que facilitan la introducción de nuevos productos.",
      "Entre las ventajas clave de trabajar con un distribuidor regional están: reducción de costos logísticos, mayor velocidad de llegada al mercado, ejecución profesional en punto de venta, gestión de inventarios y cobranza eficiente.",
      "En Grupo BG contamos con más de 17 años de experiencia distribuyendo productos de las marcas más reconocidas del Ecuador. Nuestras 4 bodegas estratégicas en Riobamba, Guaranda, Macas y Ambato nos permiten atender más de 6,000 clientes activos en 6 provincias."
    ],
    keywords: "distribuidor consumo masivo Ecuador, distribuidora productos Ecuador, distribuir productos zona centro Ecuador"
  },
  {
    id: 2,
    slug: "como-elegir-distribuidor-productos-ecuador",
    title: "Cómo Elegir el Mejor Distribuidor para Tus Productos en Ecuador",
    excerpt: "Guía completa con los factores clave que debes considerar al seleccionar un socio de distribución para tu marca en el mercado ecuatoriano.",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwyfHxwcm9kdWN0JTIwZGlzdHJpYnV0aW9uJTIwbG9naXN0aWNzJTIwc3VwcGx5JTIwY2hhaW58ZW58MHx8fHwxNzgyNTk2NTgxfDA&ixlib=rb-4.1.0&q=85",
    date: "15 Abril 2026",
    readTime: "7 min",
    category: "Negocios",
    content: [
      "Elegir un distribuidor es una de las decisiones más importantes para cualquier marca de consumo masivo. El socio correcto puede catapultar tus ventas, mientras que una mala elección puede estancar tu crecimiento en el mercado.",
      "El primer factor a considerar es la cobertura geográfica. ¿El distribuidor tiene presencia en las zonas donde quieres llegar? En Ecuador, la zona centro representa un mercado con alto potencial de crecimiento. Provincias como Chimborazo, Tungurahua y Bolívar tienen una red de comercios tradicionales que requieren atención personalizada.",
      "La infraestructura logística es fundamental. Verifica que el distribuidor cuente con bodegas propias, flota de transporte y sistemas de control de inventarios. Una empresa como Grupo BG opera desde 4 bodegas estratégicas que garantizan tiempos de entrega óptimos en toda la región.",
      "La fuerza de ventas hace la diferencia. Un equipo profesional, capacitado en técnicas de venta y merchandising, asegura que tus productos no solo lleguen al punto de venta, sino que se exhiban correctamente y se vendan al consumidor final.",
      "Evalúa el portafolio de marcas del distribuidor. Un portafolio diversificado pero no saturado indica que el distribuidor puede darle atención adecuada a cada marca. En Grupo BG manejamos 14 marcas líderes en diferentes categorías, lo que nos permite ofrecer un servicio especializado sin descuidar a ningún aliado comercial.",
      "Finalmente, considera la trayectoria y estabilidad del distribuidor. Más de 17 años en el mercado ecuatoriano nos respaldan como un socio confiable para el crecimiento de tu marca."
    ],
    keywords: "elegir distribuidor Ecuador, mejor distribuidor productos, socio distribución consumo masivo, seleccionar distribuidora"
  },
  {
    id: 3,
    slug: "distribucion-productos-riobamba-chimborazo",
    title: "Distribución de Productos en Riobamba y Chimborazo: Oportunidades de Mercado",
    excerpt: "Análisis del mercado de distribución en Riobamba y la provincia de Chimborazo, una de las zonas con mayor potencial comercial del centro del Ecuador.",
    image: "https://images.unsplash.com/photo-1587293852726-70cdb56c2866?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwxfHxwcm9kdWN0JTIwZGlzdHJpYnV0aW9uJTIwbG9naXN0aWNzJTIwc3VwcGx5JTIwY2hhaW58ZW58MHx8fHwxNzgyNTk2NTgxfDA&ixlib=rb-4.1.0&q=85",
    date: "10 Abril 2026",
    readTime: "6 min",
    category: "Mercado",
    content: [
      "Riobamba, capital de la provincia de Chimborazo, es un punto estratégico para la distribución de productos de consumo masivo en la zona centro del Ecuador. Su ubicación geográfica la convierte en un hub logístico natural para atender a varias provincias circundantes.",
      "El mercado chimboracense se caracteriza por una fuerte presencia de comercio tradicional: tiendas de barrio, bazares, minimarkets y mercados populares que son el canal principal de compra para la mayoría de la población. Esto requiere un modelo de distribución que priorice la cobertura numérica y la atención personalizada.",
      "Grupo BG tiene su sede principal en Riobamba, lo que nos da un conocimiento profundo del mercado local. Nuestra fuerza de ventas recorre diariamente las rutas de Chimborazo, visitando cada punto de venta y asegurando la disponibilidad de productos de nuestras 14 marcas aliadas.",
      "Las categorías con mayor demanda en la región incluyen alimentos, bebidas, productos de limpieza, cuidado personal y snacks. Marcas como Arcor, Estrella, Sunny, Carli Snacks y Sumesa tienen una presencia consolidada gracias a nuestra gestión de distribución.",
      "Para las marcas que buscan ingresar al mercado de Chimborazo y la zona centro, Grupo BG ofrece un modelo de distribución probado con logística eficiente, ejecución en punto de venta y un equipo comercial comprometido con el crecimiento sostenible."
    ],
    keywords: "distribución Riobamba, distribuidor Chimborazo, productos consumo masivo Riobamba, mercado Chimborazo Ecuador"
  },
  {
    id: 4,
    slug: "logistica-distribucion-zona-centro-ecuador",
    title: "Logística y Distribución en la Zona Centro del Ecuador: Retos y Soluciones",
    excerpt: "Los desafíos logísticos de distribuir productos en la sierra y oriente ecuatoriano, y cómo una operación eficiente marca la diferencia.",
    image: "https://images.unsplash.com/photo-1627309366653-2dedc084cdf1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NjV8MHwxfHNlYXJjaHwzfHxwcm9kdWN0JTIwZGlzdHJpYnV0aW9uJTIwbG9naXN0aWNzJTIwc3VwcGx5JTIwY2hhaW58ZW58MHx8fHwxNzgyNTk2NTgxfDA&ixlib=rb-4.1.0&q=85",
    date: "5 Abril 2026",
    readTime: "6 min",
    category: "Logística",
    content: [
      "La distribución de productos en la zona centro del Ecuador presenta desafíos únicos. La geografía serrana, con sus montañas y valles, junto con las extensas zonas del oriente amazónico, requiere una planificación logística rigurosa y una infraestructura adaptada a las condiciones del terreno.",
      "Las distancias entre Ambato, Riobamba, Guaranda y Macas cubren diferentes pisos climáticos y tipos de vías. Un distribuidor eficiente debe optimizar sus rutas de entrega para garantizar que los productos lleguen frescos y en buen estado a cada punto de venta, sin importar lo remoto de su ubicación.",
      "En Grupo BG hemos desarrollado un sistema logístico con 4 bodegas estratégicamente ubicadas: Riobamba como centro de operaciones, Guaranda para atender Bolívar, Ambato para Tungurahua y Pastaza, y Macas para cubrir Morona Santiago y Napo. Esta red nos permite reducir tiempos de entrega y optimizar costos de transporte.",
      "La tecnología juega un papel crucial en la logística moderna de distribución. El seguimiento de inventarios, la planificación de rutas y el control de entregas permiten maximizar la eficiencia operativa y ofrecer un servicio de calidad a nuestros más de 6,000 clientes activos.",
      "Para las marcas que necesitan cobertura en la zona centro del Ecuador, contar con un distribuidor con infraestructura propia y conocimiento del terreno es la mejor inversión para asegurar la disponibilidad de sus productos en el mercado."
    ],
    keywords: "logística distribución Ecuador, distribución sierra ecuatoriana, distribuidor zona centro Ecuador, logística Ambato Riobamba Guaranda Macas"
  }
];

// Mock function para envío de formulario
export const submitContactForm = async (formData) => {
  // Simular delay de API
  await new Promise((resolve) => setTimeout(resolve, 1000));

  console.log("Formulario enviado:", formData);

  // Simular respuesta exitosa
  return {
    success: true,
    message: "Gracias por contactarnos. Te responderemos pronto."
  };
};